'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { AppIcon } from '@/components/ui/AppIcon';

/**
 * Dark-theme switch (aria-pressed = dark on). Both icons are server-rendered and
 * CSS shows the one for the active html class, so markup never depends on the
 * stored theme (no hydration mismatch); aria-pressed is added after mount.
 */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const isDark = resolvedTheme !== 'light';
  return (
    <button
      type="button"
      className="cid-theme-toggle"
      data-cid-theme-toggle=""
      aria-label="Dark theme"
      aria-pressed={mounted ? isDark : undefined}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      <AppIcon name="MoonIcon" size={18} className="cid-theme-toggle__dark" />
      <AppIcon name="SunIcon" size={18} className="cid-theme-toggle__light" />
    </button>
  );
}
